import { IFormFieldTranslation, IRatingFormComponent } from "@edgetier/types";

export interface IProps {
    readonly autoFocus?: boolean;
    readonly children: (state: { isSelected: boolean; value: number }) => React.ReactNode;
    readonly formField: IRatingFormComponent;
    readonly translation: IFormFieldTranslation;
}

export enum RatingSentiment {
    Negative = "negative",
    Neutral = "neutral",
    Positive = "positive",
}
